import { css } from 'styled-components';
import { HeroWithMediaAndTriangleProps } from '../../../../../components/Hero/HeroWithMediaAndTriangle';
import {
  Heading,
  ReversibleGrid,
} from '../../../../../components/Hero/HeroWithMediaAndTriangle/styles';
import mediaQuery from '../../../../../helpers/mediaQuery';
import spacing from '../../../../../helpers/spacing';

export default css<HeroWithMediaAndTriangleProps & { hasMedia?: boolean }>`
  &${ReversibleGrid} {
    padding-bottom: ${({ hasMedia }) => (hasMedia ? spacing(2) : spacing(0))};
  }

  ${Heading} {
    font-size: 3.25rem;
    line-height: 3.75rem;
    margin-bottom: ${({ body, subhead }) => !body && !subhead && spacing(-2)};

    ${mediaQuery.tabletPortrait`
      font-size: 4.5rem;
      line-height: 5rem;
    `}

    ${mediaQuery.tabletLandscape`
      margin-bottom: ${({ body, subhead }) => !body && !subhead && spacing(-4)};
    `}

    ${mediaQuery.desktop`
      margin-bottom: ${({ body, subhead }) => !body && !subhead && spacing(-8)};
    `}
  }
`;
